import React, { FC, Dispatch, SetStateAction } from "react";
import { Button } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { SelectChangeEvent } from "@mui/material";
import JobsiteModal from "./modals/Jobsite/JobsiteModal";
import PoModal from "./modals/Po/PoModal";
import { styled } from "@mui/material/styles";

const StyledDivContainer = styled("div")({
  marginBottom: 10,
  border: "2px solid grey",
  padding: 5,
  textAlign: "center",
  backgroundColor: "white",
  display: "flex",
  justifyContent: "space-around",
  alignItems: "center",
});

const StyledDivWrap = styled("div")({
  display: "flex",
  justifyContent: "space-evenly",
  width: "100%",
});

const StyledCheckCircleIcon = styled(CheckCircleIcon)({
  color: "green",
  fontSize: 20,
  paddingLeft: 5,
  paddingBottom: 3,
});

const StyledErrIcon = styled(ErrorOutlineIcon)({
  color: "#d0302e",
  fontSize: 20,
  paddingLeft: 5,
  paddingBottom: 3,
});

const StyledButton = styled(Button)({
  position: "relative",
  color: "black",
});

type Jobsite = {
  contactName: string;
  contactNumber: string;
  address: string;
  city: string;
  zip: string;
  state: string;
};

interface PoJobsiteProps {
  disableChanges: boolean;
  po: string;
  jobsite: Jobsite;
  handleJobsiteChange: (
    event:
      | SelectChangeEvent<unknown>
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLTextAreaElement>,
  ) => void;
  handleAddress: (place: google.maps.places.PlaceResult) => void;
  handlePoChangeModal: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleModalDetails: () => void;
  openJobsite: boolean;
  openPO: boolean;
  handleCloseJobsite: () => void;
  handleOpenJobsite: () => void;
  handleClosePO: () => void;
  handleOpenPO: () => void;
  loadJobsite: boolean;
  err: string;
  taxResults: number[];
  handleTaxChange: (event: SelectChangeEvent<string>) => void;
  chosenTax: string | number;
  handleEditPoClick: () => void;
  editPoClicked: boolean;
  handleUpdatePoClick: (input: string) => Promise<void>;
  isUpdatingPo: boolean;
  status: string;
}

const PoJobsite: FC<PoJobsiteProps> = ({
  disableChanges,
  po,
  jobsite,
  handleJobsiteChange,
  handlePoChangeModal,
  handleModalDetails,
  openJobsite,
  openPO,
  handleCloseJobsite,
  handleOpenJobsite,
  handleClosePO,
  handleOpenPO,
  loadJobsite,
  err,
  taxResults,
  handleTaxChange,
  chosenTax,
  handleAddress,
  handleEditPoClick,
  editPoClicked,
  handleUpdatePoClick,
  isUpdatingPo,
  status,
}) => {
  const hasAllJobsiteValues =
    jobsite.contactName &&
    jobsite.contactNumber &&
    jobsite.address &&
    jobsite.city &&
    jobsite.zip
      ? true
      : false;

  return (
    <StyledDivContainer>
      <PoModal
        open={openPO}
        handleClose={handleClosePO}
        handlePoChangeModal={handlePoChangeModal}
        po={po}
        handleEditPoClick={handleEditPoClick}
        editPoClicked={editPoClicked}
        handleUpdatePoClick={handleUpdatePoClick}
        isUpdatingPo={isUpdatingPo}  status={status}      />
      <JobsiteModal
        open={openJobsite}
        handleClose={handleCloseJobsite}
        handleJobsiteChange={handleJobsiteChange}
        handleAddress={handleAddress}
        jobsite={jobsite}
        handleModalDetails={handleModalDetails}
        loadJobsite={loadJobsite}
        err={err}
        disableChanges={disableChanges}
        taxResults={taxResults}
        handleTaxChange={handleTaxChange}
        chosenTax={chosenTax}
      />

      <StyledDivWrap>
        <StyledButton
          style={{ marginRight: 10 }}
          onClick={handleOpenPO}
          variant="outlined"
          size="small"
        >
          PO#
          {po ? <StyledCheckCircleIcon /> : <StyledErrIcon />}
        </StyledButton>

        <StyledButton
          onClick={handleOpenJobsite}
          variant="outlined"
          size="small"
        >
          Jobsite Details
          {hasAllJobsiteValues ? <StyledCheckCircleIcon /> : <StyledErrIcon />}
        </StyledButton>
      </StyledDivWrap>
    </StyledDivContainer>
  );
};

export default PoJobsite;
